import InternetExplorer from "./InternetExplorer";
export default InternetExplorer;
